/*
 * ELEVE_REEL_SEQUENCE (Issue #3286)
 * トップページのInstagramコーナーにある「大人用」「子ども用」リール2本を、
 * 同時再生ではなく1本ずつ交互に再生する。エルヴェ独自追加・EURUS本体には含まれない。
 */
(function () {
  function initEleveReelSequence() {
    var containerAdult = document.querySelector(".media-social_post_HgCTt8");
    var containerKids = document.querySelector(".media-social_post_rfzkfd");
    if (!containerAdult || !containerKids) return;

    var videoAdult = null;
    var videoKids = null;
    var current = "adult";
    var wired = false;

    function pauseIfNotTurn(video, who) {
      video.addEventListener("play", function () {
        if (current !== who) video.pause();
      });
    }

    function wire() {
      if (wired) return;
      wired = true;

      videoAdult.loop = false;
      videoKids.loop = false;

      pauseIfNotTurn(videoAdult, "adult");
      pauseIfNotTurn(videoKids, "kids");

      videoAdult.addEventListener("ended", function () {
        videoAdult.pause();
        videoAdult.currentTime = 0;
        current = "kids";
        videoKids.currentTime = 0;
        videoKids.play().catch(function () {});
      });

      videoKids.addEventListener("ended", function () {
        videoKids.pause();
        videoKids.currentTime = 0;
        current = "adult";
        videoAdult.currentTime = 0;
        videoAdult.play().catch(function () {});
      });

      if (current !== "kids") videoKids.pause();
    }

    function tryWire() {
      if (!videoAdult) videoAdult = containerAdult.querySelector("video");
      if (!videoKids) videoKids = containerKids.querySelector("video");
      if (videoAdult && videoKids) wire();
    }

    tryWire();
    if (wired) return;

    var observer = new MutationObserver(function () {
      tryWire();
      if (wired) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initEleveReelSequence);
  } else {
    initEleveReelSequence();
  }
})();
